<template>
  <div class="u-wrap">
    <img class="top-img" src="@images/bg.png" />
    <div class="content">
      <div class="card_swipe">
        <van-swipe v-if="!loading" class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in banner" :key="index">
            <div class="card_swipe_s" @click="clickItem(item)">
              <img :src="item.imgUrl" />
              <div class="swipe-text">{{ item.bt }}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
        <div class=" jct2" v-if="loading">
          <van-loading type="spinner"   />
        </div>
      </div>
      <!-- 村情概况等模块 -->
      <van-grid clickable :column-num="4" :border="false" style="margin-top: 10px">
        <van-grid-item v-for="(item, index) in menuList" :key="index" @click="clickGrid(index)">
          <img :src="item.icon" class="grid-img" />
          <div class="grid-text1">{{ item.title }}</div>
          <div v-if="index==7" class="launch-btn">
           <wx-open-launch-weapp id="launch-btn1" username="gh_071380d680d3" path="pages/index/index">
                  <script type="text/wxtag-template">
                       <style>.xbox{width: 100%;height:100%;display: flex;justify-content: center;flex-wrap: wrap;}.btn { border: 0;outline: none;opacity:0;-webkit-tap-highlight-color:transparent !important;font-size: 12px;text-align: center;width: 100%;height:80px}</style>
                       <div class="xbox">
                    <div class="btn">秦务员</div>
                       </div>
                  </script>
            </wx-open-launch-weapp>
            </div>
        </van-grid-item>
      </van-grid>
      <div class="llhzc">
        <img @click="goRxfw()" src="@images/gzfw/bg-fwrx.png" />
        <img @click="clickLxwg()" src="@images/gzfw/bg-lxwg.png" />
        <img @click="clickZjgsl()" src="@images/gzfw/bg-zjgsl.png" />
        <img @click="clickSqq()"  src="@images/gzfw/bg-wswx.png" />
        <img @click="clickMqztc()" style="width: 100%;" src="@images/gzfw/bg-mqztc.png" />
        <img v-if="ztImg" @click="clickZt()"  style="width: 100%;" :src="ztImg" />
      </div>

      <div class="card card2">
        <div class="title">
          <p>长武同城</p>
          <p @click="$router.push('hmhq/wall')">更多</p>
        </div>
        <div class="card2-content">
          <div v-for="(item, index) in wallList" :key="index" @click="goPage(item)">
            <img :src="item.pth" alt="" />
          </div>
        </div>
      </div>

       <div class="card card2">
        <div class="title">
          <p>便民指南</p>
          <p @click="clickMore('02')">更多</p>
        </div>
        <div v-if="list1.length>0"  class="card2-content2">
          <div v-for="(item, index) in list1" :key="index" @click="clickItem(item)">
            <div class="card2-content2-l">
              <img :src="item.tpIndex" alt="" />
            </div>
            <div class="card2-content2-r">
              <p><img src="@images/new.png" /> {{ item.bt }}</p>
              <p>发布时间{{ item.createTime }}</p>
            </div>
          </div>
        </div>
        <div v-else class="card2-content2 zwsj">
           <img src="@images/nodata.png"/>
        </div>
      </div>

      <div class="card card2">
        <div class="title">
          <p>政策之窗</p>
          <p @click="clickMore('01')">更多</p>
        </div>
        <div class="card2-content2">
          <div v-for="(item, index) in list" :key="index" @click="clickItem(item)">
            <div class="card2-content2-l">
              <img :src="item.tpIndex" alt="" />
            </div>
            <div class="card2-content2-r">
              <p><img src="@images/new.png" /> {{ item.bt }}</p>
              <p>发布时间{{ item.createTime }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="card card2">
        <div class="title">
          <p>长武新闻</p>
          <p @click="clickCwxw">更多</p>
        </div>
        <div class="card2-content2">
          <div v-for="(item, index) in cwxwList" :key="index" @click="clickItem(item)">
            <div class="card2-content2-l">
              <img v-if="item.tp" :src="item.tp.split(',')[0]" alt="" />
            </div>
            <div class="card2-content2-r">
              <p><img src="@images/new.png" /> {{ item.bt }}</p>
              <p>发布时间：{{ item.createTime }}</p>
            </div>
          </div>
        </div>
      </div>

       <!-- <div class="card card2">
        <div class="title">
          <p>便民指南</p>
          <p @click="clickMore('02')">更多</p>
        </div>
        <div class="card2-content2">
          <div v-for="(item, index) in list1" :key="index" @click="clickItem(item)">
            <div class="card2-content2-l">
              <img :src="item.tpIndex" alt="" />
            </div>
            <div class="card2-content2-r">
              <p><img src="@images/new.png" /> {{ item.bt }}</p>
              <p>发布时间{{ item.createTime }}</p>
            </div>
          </div>
        </div>
      </div> -->

      <smrzPop v-model="show"></smrzPop>
    </div>
  </div>
</template>

<script>
import { getAction, postAction, postParam } from '@/api/manage'
import FileMixin from '@/views/common/mixins/file-mixin.js'
import OpenIdMixin from '@/views/common/mixins/openId-mixin.js'
import { gzfwMenu } from '@/utils/work'
import { ImagePreview, Toast } from 'vant'
import wx from 'weixin-js-sdk'
import smrzPop from '../common/smrz-pop.vue'
import { getGenderByIdNumber, strToUtf8Bytes, strToHexCharCode } from '@/utils/util'
import Vue from 'vue'
export default {
  components: { smrzPop },
  mixins: [FileMixin, OpenIdMixin], // 使用mixin (在main.js注册全局组件)
  data() {
    return {
      list: [],
      show: false,
      pageNo: 1,
      object: {},
      dataList: [],
      xxzzList: [],
      cunName: '',
      searchType: 'xzdt' /**查询类型 xzdt 县镇动态 cqdt 村情动态*/,
      current: 0,
      swiperIndex: 0,
      menuList: gzfwMenu,
      wallList: [
        {
          title: '失物招领',
          code: '01',
          id: 1,
          pth: require('@images/gzfw/bg-swzl.png'),
        },
        {
          title: '房屋租聘',
          code: '02',
          id: 2,
          pth: require('@images/gzfw/bg-fwzl.png'),
        },
        {
          title: '招聘信息',
          code: '03',
          id: 3,
          pth: require('@images/gzfw/bg-zpxx.png'),
        },
        {
          title: '线上市场',
          code: '04',
          id: 4,
          pth: require('@images/gzfw/bg-jypx.png'),
        },
      ],
      banner: [],
      cwxwList:[],
      loading:true,
      sfInfoList:[],
      ztImg:'',
      list1:[],
    }
  },
  created() {
    this.swiperIndex = this.$store.state.swiperIndex
    this.initData()
    this.initOpenId()
      .then((res) => {
        this.getSfInfo();
        this.initWxInfo()
           
        // if (this.isSmrz()) {
        //   this.object = this.getSmrzData()
        //   this.getNameByCode(this.object.sysOrgCode)
        // } else {
        //   this.finished = true
        // }
      })
      .catch((err) => {
        this.finished = true
      })
  },
  computed: {},
  methods: {
    initData() {
      this.getBanner()
      this.getZczc('01')
      this.getCwxw()
      this.getZt();
      this.getZczc('02')
     
    },
    initWxInfo() {
      // let urlHref = encodeURIComponent(window.location.href)
      let urlHref = encodeURIComponent(window.location.href.split('#')[0])
      let params = { url: urlHref }
      let url = `/sys/mlogin/get/jsdk?url=${urlHref}`
      postAction(url, params).then((res) => {
        if (res.success) {
          let obj = res.result
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: obj.appId, // 必填，公众号的唯一标识
            timestamp: obj.timestamp, // 必填，生成签名的时间戳
            nonceStr: obj.nonceStr, // 必填，生成签名的随机串
            signature: obj.signature, // 必填，签名，见附录1
            jsApiList: [
              'getLocation',
              'chooseImage',
              'startRecord',
              'stopRecord',
              'onVoiceRecordEnd',
              'playVoice',
              'onVoicePlayEnd',
              'pauseVoice',
              'stopVoice',
              'uploadVoice',
              'downloadVoice',
            ],
            openTagList: ['wx-open-launch-weapp'],
            gglList: [],
          })
          // this.getUrl()
        }
      })
      wx.ready(function () {
        console.log('config ready0')
      })
      wx.error(function () {
        console.log('config error0')
      })
    },
    changeSwipe(idx) {
      console.log('idx', idx)
      this.$store.state.swiperIndex = idx
    },
    goLyjq(item) {
      console.log('跳旅游景区', item)
      let params = {
        id: item.id,
      }
      this.$router.push({
        path: '/hmhq/lyjqView',
        query: params,
      })
    },
    getBanner() {
      let params = {
        sxxxtz: '1',
        pageNo: '1',
        pageSize: '5',
      }
      getAction('/zhshj/gzfwlbt/page', params).then((res) => {
         this.loading = false;
        if (res.code == 200) {
          let data = res.result.records
          data.map((item, index) => {
            item.imgUrl = item.tp.split(',')[0]
          })
          this.banner = data
          console.log('轮播图', this.banner)
        }
      })
    },
    getSfInfo(){
      let smrzInfo = this.getSmrzData();
       let params = {
        idNumber: smrzInfo.idNumber,
      }
      getAction('/zhshj/ldbwygl/query/by/idnumber', params).then((res) => {
        if (res.success) {
          let data = res.result
          this.sfInfoList = data; 
          Vue.ls.set('sfInfo',JSON.stringify(data))  
         }
      })
    },
    getCwxw() {
      let params = {
        pageNo: '1',
        pageSize: '3',
      }
      getAction('/zhshj/gzfwlbt/page', params).then((res) => {
        if (res.code == 200) {
          let data = res.result.records
          this.cwxwList = data
        }
      })
    },
    getZt() {
      getAction('/zhshj/jfscztgl/zt').then((res) => {
        if (res.code == 200) {
           let obj = res.result;
              if(obj){
               let ztlx = obj.ztlx;
               if(ztlx=='04'){
                this.ztImg = obj.tp 
               }else{
                this.ztImg = require(`@images/gzfw/bg${ztlx}.png`) 
               }
              }
        }
      })
    },
    /**
     * 政策之窗（'01'），便民指南（'02')
     */
    getZczc(type) {
      let params = { type, pageNo: '1', pageSize: '3'}
      getAction('/zhshj/hmfwggl/page', params).then((res) => {
        let list = res.result.records
        if (list && list.length) {
          list.map((item, index) => {
            if (item.tp) {
              item.tpIndex = item.tp.split(',')[0]
            } else {
              item.tpIndex = require('@images/people/bg.png')
            }
          })
          if(type=='01'){
             this.list = list
          }else{
             this.list1 = list
          }
         
        }
      })
    },

    //获取小程序地址
    // getUrl() {
    //   let script = document.createElement('script')
    //   script.type = 'text/wxtag-template'
    //   script.text = `<div style="width: 100%;height:90px;"></div>`
    //   //办事指南
    //   this.wxHtml1 = `<wx-open-launch-weapp
		// 				style="position: absolute;height: 50px;width: 100%;transform: translateX(-45%);" id="launch-btn1"
		// 				username="gh_071380d680d3"
		// 				path="pages/index/index"
		// 			>${script.outerHTML}
		// 		</wx-open-launch-weapp>`
    //   //异地就医
    //   this.wxHtml2 = `<wx-open-launch-weapp
		// 				style="position: absolute;height: 50px;width: 100%;transform: translateX(-45%);" id="launch-btn2"
		// 				username="gh_95fd1700c01e"
		// 				path="pages/common/launch-screen"
		// 			>${script.outerHTML}
		// 		</wx-open-launch-weapp>`
    //   //车次查询
    //   this.wxHtml3 = `<wx-open-launch-weapp
		// 				style="position: absolute;height: 50px;width: 100%;transform: translateX(-45%);" id="launch-btn3"
		// 				username="gh_a982e843b128"
		// 				path="pages/bus/index/index"
		// 			>${script.outerHTML}
		// 		</wx-open-launch-weapp>`
    //   this.$nextTick(() => {
    //     let launchButton = document.getElementById('launch-btn1')
    //     launchButton.addEventListener('launch', function (e) {
    //       console.log('1success', e.detail)
    //     })
    //     launchButton.addEventListener('error', function (e) {
    //       console.log('1sfail', e.detail)
    //     })
    //     let launchButton2 = document.getElementById('launch-btn2')
    //     launchButton2.addEventListener('launch', function (e) {
    //       console.log('1success', e.detail)
    //     })
    //     launchButton2.addEventListener('error', function (e) {
    //       console.log('1sfail', e.detail)
    //     })
    //     let launchButton3 = document.getElementById('launch-btn3')
    //     launchButton3.addEventListener('launch', function (e) {
    //       console.log('1success', e.detail)
    //     })
    //     launchButton3.addEventListener('error', function (e) {
    //       console.log('1sfail', e.detail)
    //     })
    //   })
    // },
    clickSmrz() {
      if (!this.isSmrz()) {
        this.show = true
      } else {
        let params = this.getSmrzData()
        params.sysOrgCode_dictText = this.cunName
        this.$router.push({
          name: 'smrz-view',
          params: params,
        })
      }
    },

    clickMore(type) {
        this.$router.push({
          path: '/xxgk/tzgg',
          query:{type},
        })
    },
    clickMenu(path) {
      if (this.isSmrz()) {
        this.$router.push({
          path: path,
        })
      } else {
        this.show = true
      }
    },
    goPage(item) {
         this.$router.push({
          path: '/hmhq/wall-list',
          query: item,
        })
      // if (this.isSmrz()) {
      //   this.$router.push({
      //     path: '/hmhq/wall-list',
      //     query: item,
      //   })
      // } else {
      //   this.show = true
      // }
    },
    clickXxgk(code, title) {
      if (this.isSmrz()) {
        let params = { code: code, title: title }
        this.$router.push({
          path: 'xxgk/xxgk',
          query: params,
        })
      } else {
        this.show = true
      }
    },
    clickFwrx() {
      if (this.isSmrz()) {
        this.$router.push({
          path: 'hmhq/fwrx',
        })
      } else {
        this.show = true
      }
    },
    clickHbls(code, title) {
      if (this.isSmrz()) {
        let params = { code: code, title: title }
        this.$router.push({
          path: 'xxgk/hbls',
          query: params,
        })
      } else {
        this.show = true
      }
    },
    clicPages(pth) {
      window.location.href = pth
    },
    clickDxal(code, title) {
      if (this.isSmrz()) {
        let params = { code: code, title: title }
        this.$router.push({
          path: 'xxgk/dxal',
          query: params,
        })
      } else {
        this.show = true
      }
    },
    goRxfw() {
      this.addTj('14')
      window.location.href = 'tel:02938112345'
    },
    clickHmhq(code, title, pth) {
      if (code == 0) {
        Toast('暂未开放')
        return
      }
      if (this.isSmrz()) {
        let params = { code: code, title: title }
        this.$router.push({
          path: 'hmhq/' + pth,
          query: params,
        })
      } else {
        this.show = true
      }
    },
    getNameByCode(code) {
      let params = { category: '2' }
      getAction('/sys/sysDepart/queryTreeList/by/category/xzzz', params).then((res) => {
        if (res.success) {
          let list = res.result
          this.cunName = this.getName(list, code)
        }
      })
    },
    getName(list, code) {
      console.log(code)
      let zhenCode = code.substring(0, 6)
      let arr = list[0].children.filter((obj) => {
        return obj.orgCode == zhenCode
      })

      let zhenObj = arr[0]

      let arr1 = zhenObj.children.filter((obj) => {
        return obj.orgCode == code
      })
      console.log(arr1)
      let name = zhenObj.title + arr1[0].title
      return name
    },

    preImage(index, imgList) {
      ImagePreview({
        images: imgList,
        startPosition: index,
      })
    },
    clickFzjz() {
      if (this.isSmrz()) {
        this.$router.push({
          path: 'xxgk/fzjz-list',
        })
      } else {
        this.show = true
      }
    },
    clickGrid(index) {
      switch (index) {
        case 0:
          this.clickMenu('/gzfw/cwl')
          break
        case 1:
          // this.goSmrzPath('/pages/home/ssp')
          this.clickMenu('/hmhq/ssp')
          break
        case 2:
          this.clickMenu('/gzfw/cxzc')

          break
        case 3:
          this.clickMenu('/gzfw/fzsb')
          break
        case 4:
          this.$router.push({
            path: '/gzfw/bszn',
          })
          break
        case 5:
          this.addTj('08')
          this.clicPages('http://legalinfo.moj.gov.cn/')
          break
        case 6:
          this.clickMenu('/xxgk/wytp')
          break
        case 7:
          // this.goWmsj()
          //  this.addTj('10')
          // this.clicPages('https://cwxxsd.deepoceanbd.com/h5')
          break
        case 8:
          this.clickMenu('/hmhq/wyfw')
          break
        case 9:
           this.$router.push({
            path: '/hmhq/lyjq',
          })
          break
        case 10:
          //   this.$router.push({
          //   path: '/gzfw/fyzx',
          // })
          this.clicPages('http://hyyy.saxmz.gov.cn/index')
          break
        case 11:
          sessionStorage.setItem("go_xcx",1)
            this.$router.push({
            path: '/xxgk/more',
          })
          break
        default:
          break
      }
    },
    clickItem(item) {
      this.$store.state.tzggView = item
      this.$router.push({
        path: '/xxgk/tzgg-view',
      })
    },
    clickCwxw() {
      this.$router.push({
        path: '/gzfw/cwxw-list',
      })
    },
    clickLxwg() {
        if (!this.isSmrz()) {
           this.show = true
            return;
       } 
      this.getBlhLxdh().then((res) => {
        this.addTj('15')
        let phone = res.message
        window.location.href = `tel:${phone}`
      })
    },
    clickZjgsl(){
      if (!this.isSmrz()) {
           this.show = true
            return;
       } 
       this.$router.push({
          path: '/xxgk/tzgg',
          query:{type:'03'},
        })
    },
    getBlhLxdh() {
      return new Promise((resolve, reject) => {
        getAction('/zhshj/csqryglwgy/getWgybybly').then((res) => {
          if (res.success) {
            resolve(res)
          } else {
             this.goLxwg();
            // this.$toast(res.message)
          }
        })
      })
    },
      goLxwg(){
         this.$router.push({
        path: '/gzfw/lxwg',
      })
      },
    clickSqq() {
      this.clickMenu('/gzfw/sqq')
    },
     clickMqztc() {
      if (!this.isSmrz()) {
        this.show = true;
        return;
      }

      if(this.sfInfoList.length==0){
        return this.$toast('您不是党代表、人大代表、政协委员，无查看权限')
      }
      this.clickMenu('/gzfw/mqztc')
    },
    addTj(code) {
      let params = { gpfwmblx: code }
      getAction('/zhshj/gpfwmb/add/tj', params).then((res) => {
        if (res.suuccess) {
        }
      })
    },
    clickZt(){
       this.YzJfsc().then(()=>{
           this.clickMenu('/gzfw/jfsc')
        })
    },
      YzJfsc(){
        return new Promise((resolve, reject) => {
          
         getAction('/zhshj/jfschdgl/hdxx').then(res => {
            if (res.success) {
              let obj = res.result[0];
              if(obj.zt=='01'){
                resolve();
              }else{
                let message = `积分商城已在${obj.gbsj}关闭，开放时间：${obj.kfsj}`
                this.$toast(message)
                reject();
              }
            }else{
              reject();
            }
          });
        })
      },
    goWmsj() {
      if (!this.isSmrz()) {
        this.show = true
        return
      }
      let obj = this.getSmrzData()
      const mobile = obj.phone
      const name = obj.wechatName
      const idCard = obj.idNumber
      const sex = getGenderByIdNumber(obj.idNumber)
      let params = { name, sex, idCard, mobile }
      // let params ={"name":"测试","sex":1,"idCard":"37081119890826603X","mobile":"18678768992"}
      let hexCode = strToHexCharCode(strToUtf8Bytes(JSON.stringify(params)))
      const hexLowerCase = hexCode.toLocaleLowerCase()
      let path = `https://cwxxsd.deepoceanbd.com/h5?param=${hexLowerCase}`
      this.addTj('10')
      this.clicPages(path)
    },
  },
}
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}
.u-wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.card {
  height: auto;
  overflow: hidden;
  margin-top: 12px;
}
.card2 {
  // margin:0px 8px 10px;
  // padding: 12px 8px;
  .title {
    width: 100%;
    position: relative;
    margin: 0px 0px 10px;
    display: flex;
    box-sizing: border-box;
    padding: 0px 0px 0px 10px;
    justify-content: space-between;
    p {
      margin: 0px;
      padding: 0px;
      letter-spacing: 1px;
      font-size: 15px;
    }
    p:last-child {
      color: #999;
      font-size: 14px;
    }
  }
  .title::before {
    content: '';
    width: 4px;
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    background: #0f3cff;
  }
  &-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    div {
      width: 49%;
      display: flex;
      margin: 0px 0px 10px;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
      }
    }
  }
  &-content2 {
    > div {
      display: flex;
      height: 80px;
      margin: 0px 0px 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      justify-content: space-between;
    }
    > div:last-child {
      border-bottom: none;
      margin-bottom: 0px;
    }
    &-l {
      width: 75px;
      height: 65px;
      display: flex;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        background-color: #e6e6e6;
      }
    }
    &-r {
      width: 74%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;
      flex-direction: column;
      position: relative;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
      }
      p {
        margin: 0px;
        padding: 0px;
        font-size: 14px;
        overflow: hidden;
        line-height: 20px;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        display: -webkit-box;
      }
      > p:first-child {
        // text-indent: 2.5em;
        // display: block;
      }
      > p:last-child {
        // text-indent: 2.5em;
        display: block;
        font-size: 12px;
        color: #b5b5b5;
      }
      img {
        height: 12px;
        // left: 0px;
        // top: 4px;
        // position: absolute;
      }
    }
  }
}

.csq {
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
}

.flex-center {
  display: flex;
  align-items: center;
}

.text {
  font-size: 14px;
  color: #666666;
  margin-left: 10px;
}

.csq .value {
  font-size: 14px;
  font-weight: 400;
  color: #333333;
}
.grid-img {
  width: 40px;
  height: 40px;
}

.grid-img1 {
  width: 27px;
  height: 28px;
}

.grid-text {
  margin-top: 9px;
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  text-align: center;
}

.line-2 {
  height: 44px;
}

.dt-title {
  text-align: center;
  line-height: 36px;
  font-size: 17px;
  color: #333333;
}

.line {
  margin: 0 12px;
  height: 1px;
  background-color: #ededed;
}

.ssdt-item {
  display: flex;
  padding: 12px;
  border-bottom: 1px solid #ededed;
}

.left-img {
  width: 38px;
  height: 38px;
  margin-top: 5px;
}

.right-content {
  flex: 1;
  margin-left: 10px;
}

.name {
  font-size: 15px;
  font-weight: 400;
  color: #333333;
  line-height: 22px;
}

.right-content .content {
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  font-size: 14px;
  color: #333333;
  line-height: 16px;
  max-height: 110px;
  height: auto;
  text-overflow: ellipsis;
  overflow: hidden;
}

.right-content .content2s {
  max-height: 1000px;
  height: auto;
  // height: auto !important;
}

.right-content .time {
  color: #999;
  font-size: 14px;
}

.popup-content {
  width: 290px;
  height: 317px;
  position: relative;
}

.d-title {
  font-size: 18px;
  font-weight: 600;
  color: #3875f6;
  line-height: 25px;
  margin-top: 26px;
  text-align: center;
}

.d-content {
  font-size: 14px;
  font-weight: 500;
  color: #999999;
  line-height: 18px;
  margin: 16px 24px 32px;
  text-align: center;
}
.d-button {
  width: 80%;
  height: 38px;
  line-height: 38px;
  background: #3875f6;
  color: #ffffff;
  font-size: 15px;
  border-radius: 38px;
  margin-left: 10%;
  border: none;
}

.close {
  width: 24px;
  height: 24px;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
}

.dz-img {
  width: 16px;
  height: 16px;
}
.dz-text {
  color: #3875f6;
  margin-left: 6px;
}

.dz-content {
  margin-top: 7px;
  height: auto;
  background: #f6f6f6;
  padding: 8px;
  position: relative;
}

.dz-t {
  color: #3875f6;
  margin-left: 10px;
  line-height: 18px;
}

.sjx {
  border-bottom: 8px solid #f6f6f6;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  width: 1px;
  margin-left: 10px;
}

.notice-swipe {
  height: 40px;
  line-height: 40px;
}

.lb {
  width: 15px;
  height: 14px;
  position: absolute;
  top: 13px;
  left: 12px;
}

.imgList {
  display: flex;
  flex-wrap: wrap;
  padding-top: 10px;
}
.imgList .images {
  width: 80px;
  height: 80px;
  margin: 0 10px 10px 0;
}

.grid-text1 {
  font-size: 13px;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  width: 100%;
  text-align: center;
  color: #1a1a1a;
}

.title {
  font-size: 14px;
  font-weight: bold;
  padding-left: 12px;
}

::v-deep .van-grid-item__content {
  padding: 10px 4px;
  background-color: #fff;
  position: relative;
}
.my-swipe .van-swipe-item {
  /* color: #fff; */
  font-size: 20px;
  width: 100%;
  text-align: center;
  background-color: white;
}
::v-deep .van-tab {
  font-size: 16px;
}
.my-swipe /deep/ .van-swipe__indicators {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 2px 5px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.1);
  left: auto;
  transform: none;
}
.llhzc {
  display: flex;
  margin: 10px 0;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.llhzc img {
  width: 49%;
  border-radius: 8px;
  margin-bottom: 10px;
}
/* .wx-open-weapp {
  flex-basis: 25%;
  height: 70px;
} */
#launch-btn1,
#launch-btn2,
#launch-btn3 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  -webkit-tap-highlight-color:transparent !important
}
.btn11 {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  opacity: 0;
}
.btn11 /deep/ .van-grid-item__content {
  height: 100%;
}
.btn11 /deep/ .grid-text1 {
  font-size: 12px;
  margin-top: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  width: 100%;
  text-align: center;

  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.card_swipe {
  width: 100%;
  height: 150px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  .card_swipe_s {
    height: 150px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .swipe-text {
      position: absolute;
      width: 100%;
      bottom: 0px;
      height: 38px;
      color: #eee;
      background: rgba(0, 0, 0, 0.5);
      padding-left: 12px;
      line-height: 38px;
      text-align: left;
      font-size: 14px;
      padding-right: 50px;
      word-break: keep-all;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .my-swipe .van-swipe-item {
    color: #fff;
    font-size: 20px;
    height: 100%;
    text-align: center;
  }
}
.content-zd {
  font-size: 13px;
  margin: 6px 0px 0px;
  opacity: 0.5;
}
.xcx_icon {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  opacity: 0;
}

.top-img {
  width: 100%;
  height: auto;
}
.content {
  padding: 0 15px 15px 15px;
  position: relative;
  margin-top: -100px;
}

.jct{
  width: 100%;
  display: flex;
  min-height: 100px;
  padding: 20px 0px 0px;
  justify-content: center;
}
.jct2{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%)
}

.zwsj{
  display: flex;
  align-items: center;
  justify-content: center;

  img{
    width: 65%;
  }
}

.launch-btn{
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0;
}

</style>